// Payment product configurations
export const PAYMENT_PRODUCTS = {
  PDF_ONE_TIME: {
    id: 'pdf_one_time',
    name: 'One-Time PDF Download',
    description: 'Single PDF export of your CV',
    price: 0.99,
    currency: 'eur',
    unit_amount: 99, // Stripe amount in cents
    type: 'one_time',
    validity: null,
    metadata: {
      service: 'pdf_download',
      type: 'one_time',
      downloads: '1'
    }
  },
  PDF_24H: {
    id: 'pdf_24h',
    name: '24 Hour Pass',
    description: 'Unlimited downloads for 24 hours + access code',
    price: 1.99,
    currency: 'eur',
    unit_amount: 199, // Stripe amount in cents
    type: 'time_limited',
    validity: '24h',
    metadata: {
      service: 'pdf_download',
      type: 'time_limited',
      duration: '24h',
      downloads: 'unlimited',
      includes_code: 'true'
    }
  },
  PDF_WEEK: {
    id: 'pdf_week',
    name: 'Week Pass',
    description: 'Unlimited downloads for 7 days + access code',
    price: 4.99,
    currency: 'eur',
    unit_amount: 499, // Stripe amount in cents
    type: 'time_limited',
    validity: '7d',
    metadata: {
      service: 'pdf_download',
      type: 'time_limited',
      duration: '7d',
      downloads: 'unlimited',
      includes_code: 'true'
    }
  },
  PDF_MONTH: {
    id: 'pdf_month',
    name: 'Month Pass',
    description: 'Unlimited downloads for 30 days + access code',
    price: 7.99,
    currency: 'eur',
    unit_amount: 799, // Stripe amount in cents
    type: 'time_limited',
    validity: '30d',
    metadata: {
      service: 'pdf_download',
      type: 'time_limited',
      duration: '30d',
      downloads: 'unlimited',
      includes_code: 'true'
    }
  }
};

// Helper function to get product by ID
export const getProductById = (productId) => {
  return Object.values(PAYMENT_PRODUCTS).find(product => product.id === productId);
};

// Helper function to format price for display
export const formatPrice = (product, locale = 'en-US') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: product.currency.toLowerCase()
  }).format(product.price);
};

// Helper function to get product features for display
export const getProductFeatures = (product) => {
  const baseFeatures = ['Professional formatting', 'ATS-friendly layout'];
  
  switch (product.type) {
    case 'one_time':
      return [
        'Single PDF download',
        ...baseFeatures,
        'Perfect for one application'
      ];
    case 'time_limited':
      const duration = product.validity === '24h' ? '24 hours' : 
                      product.validity === '7d' ? '7 days' : 
                      product.validity === '30d' ? '30 days' : product.validity;
      return [
        `Unlimited downloads for ${duration}`,
        'Access code for future use',
        ...baseFeatures,
        'Perfect for job search periods'
      ];
    default:
      return baseFeatures;
  }
};

export default PAYMENT_PRODUCTS; 